import React from "react";
import Input from "./Input";

const RecordsData = ({ record, formattedDate, save }) => {
  const accCat = record?.category ? record?.category?.split("_")[1] : "";
  return (
    <div className="grid grid-cols-12 gap-[8px]">
      <div className="col-span-12">
        <div className="flex items-center justify-between mb-0.5">
          <h2 className="text-primary-400 text-[13px] font-medium">
            {save ? "Saved Record" : "Published Record"}
          </h2>
          <h2 className="text-primary-400 text-[13px] font-medium">
            Date: {formattedDate}
          </h2>
        </div>
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Fees ID"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.FID}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Doctor ID, Name"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={`${record?.DID}`}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Date"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={formattedDate}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Period"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.period}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Gateways"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.gateways}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-4">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Paid Fees"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.paidRent}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Category"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={accCat?.toUpperCase()}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Account"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.account}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Trx Type"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.trxType}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
      <div className="col-span-12 md:col-span-6 lg:col-span-3">
        <Input
          inputBox="mb-0"
          type="text"
          labelName="Trx ID"
          labelClassName="block text-primary-400 text-[13px] leading-[20px]"
          className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
          value={record?.trxId}
          disabled
          disabledClass="bg-primary-50 border-primary-50 "
          padding="none"
        />
      </div>
    </div>
  );
};

export default RecordsData;
